/* GEHNA FOR YOU — CRO JS — No COD, cart shipping bar in Liquid */
(function(){
'use strict';
var FREE_SHIP_THRESHOLD = 99900;
var INSTA_FOLLOWERS = '73.1K';
var INSTA_URL = 'https://www.instagram.com/gehna_foryouu/';
var GOOGLE_URL = 'https://share.google/PNBLtnqKZ573wKJSI';

function injectWAFab(){
  if(document.querySelector('.gehna-wa-fab')) return;
  var a=document.createElement('a'); a.className='gehna-wa-fab';
  a.href='https://wa.me/918500531018?text=Hi%20Gehna%20For%20You!%20I%20need%20help%20with%20jewellery.';
  a.target='_blank'; a.rel='noopener'; a.setAttribute('aria-label','Chat on WhatsApp');
  a.innerHTML='<svg viewBox="0 0 24 24" fill="white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>';
  document.body.appendChild(a);
}

function injectBTT(){
  if(document.querySelector('.gehna-btt')) return;
  var btn=document.createElement('button'); btn.className='gehna-btt'; btn.setAttribute('aria-label','Back to top');
  btn.innerHTML='<svg fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="18 15 12 9 6 15"/></svg>';
  document.body.appendChild(btn);
  window.addEventListener('scroll',function(){btn.classList.toggle('visible',window.scrollY>400);},{passive:true});
  btn.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'});});
}

function injectStickyATC(){
  var origBtn=document.querySelector('.product-form__submit');
  if(!origBtn||document.querySelector('.gehna-sticky-atc')) return;
  var title=document.querySelector('.product__title h1');
  var price=document.querySelector('.price--large .price-item--regular,.price--large .price-item--sale,.price--large .price-item');
  var img=document.querySelector('.product__media img');
  var bar=document.createElement('div'); bar.className='gehna-sticky-atc';
  bar.innerHTML=(img?'<img class="gehna-sticky-atc__img" src="'+img.src.replace(/&width=\d+/,'&width=120')+'" alt="" loading="lazy">':'')+
    '<div class="gehna-sticky-atc__info"><div class="gehna-sticky-atc__name">'+(title?title.textContent.trim():'')+
    '</div><div class="gehna-sticky-atc__price">'+(price?price.textContent.trim():'')+'</div></div>'+
    '<button class="gehna-sticky-atc__btn" type="button">Add to Cart &#10004;</button>';
  document.body.appendChild(bar);
  var io=new IntersectionObserver(function(e){bar.classList.toggle('visible',!e[0].isIntersecting);},{threshold:0});
  io.observe(origBtn);
  bar.querySelector('.gehna-sticky-atc__btn').addEventListener('click',function(){
    origBtn.click(); this.textContent='Adding...';
    var s=this; setTimeout(function(){s.textContent='Added!';s.style.background='#22c55e';},600);
    setTimeout(function(){s.textContent='Add to Cart';s.style.background='';},2200);
  });
}

/* ── Trust badges + social proof ──────────────────────────────────────────
   Inserted AFTER the buy-buttons form wrapper so they appear below
   Add to Cart / Buy Now, not below the price.
──────────────────────────────────────────────────────────────────────── */
function getBuyButtonsAnchor(){
  /* product-form__buttons is the wrapper around ATC + dynamic checkout */
  var anchor = document.querySelector('.product-form__buttons');
  /* fallback: the product-form element itself */
  if(!anchor) anchor = document.querySelector('product-form');
  /* last fallback: the submit button's parent */
  if(!anchor){
    var btn = document.querySelector('.product-form__submit');
    if(btn) anchor = btn.parentNode;
  }
  return anchor;
}

function injectTrustBadges(){
  if(document.querySelector('.gehna-trust-badges')) return;
  var anchor = getBuyButtonsAnchor();
  if(!anchor) return;

  var b=document.createElement('div'); b.className='gehna-trust-badges';
  b.innerHTML=
    '<div class="gehna-trust-badge">'+
      '<div class="gehna-trust-badge-icon">&#128666;</div>'+
      '<div class="gehna-trust-badge-title">Free Delivery</div>'+
      '<div class="gehna-trust-badge-desc">Orders above &#8377;999</div>'+
    '</div>'+
    '<div class="gehna-trust-badge">'+
      '<div class="gehna-trust-badge-icon">&#128737;</div>'+
      '<div class="gehna-trust-badge-title">Transit Safe</div>'+
      '<div class="gehna-trust-badge-desc">Exchange if damaged in transit</div>'+
    '</div>'+
    '<div class="gehna-trust-badge">'+
      '<div class="gehna-trust-badge-icon">&#128274;</div>'+
      '<div class="gehna-trust-badge-title">Secure Pay</div>'+
      '<div class="gehna-trust-badge-desc">UPI / Cards / Net Banking</div>'+
    '</div>'+
    '<div class="gehna-trust-badge">'+
      '<div class="gehna-trust-badge-icon">&#128249;</div>'+
      '<div class="gehna-trust-badge-title">Video Call</div>'+
      '<div class="gehna-trust-badge-desc">Shop via WhatsApp</div>'+
    '</div>';
  anchor.insertAdjacentElement('afterend', b);

  var sb=document.createElement('div'); sb.className='gehna-social-badges';
  sb.innerHTML=
    '<a href="'+GOOGLE_URL+'" target="_blank" rel="noopener" class="gehna-social-badge gehna-social-badge--google">'+
      '<svg viewBox="0 0 24 24" width="14" height="14"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>'+
      '<span>&#11088;&#11088;&#11088;&#11088;&#11088; 5-Star Google</span>'+
    '</a>'+
    '<a href="'+INSTA_URL+'" target="_blank" rel="noopener" class="gehna-social-badge gehna-social-badge--insta">'+
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>'+
      '<span>'+INSTA_FOLLOWERS+' Followers</span>'+
    '</a>';
  b.insertAdjacentElement('afterend', sb);
}

function injectDeliveryBar(){
  if(document.querySelector('.gehna-delivery-bar')) return;
  var anchor = getBuyButtonsAnchor(); if(!anchor) return;
  var bar=document.createElement('div'); bar.className='gehna-delivery-bar';
  bar.innerHTML='<svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"/></svg><span>Ships within <strong>24-48 hours</strong> &bull; Delivered in <strong>3-5 days</strong> across India</span>';
  /* Insert after trust badges / social badges if they exist, else after anchor */
  var sb = document.querySelector('.gehna-social-badges');
  var insertAfter = sb || document.querySelector('.gehna-trust-badges') || anchor;
  insertAfter.insertAdjacentElement('afterend', bar);
}

function injectWAProductBtn(){
  if(document.querySelector('.gehna-wa-btn')) return;
  var anchor = getBuyButtonsAnchor(); if(!anchor) return;
  var title=document.querySelector('.product__title h1');
  var msg='Hi Gehna For You! I am interested in '+(title?title.textContent.trim():'this product')+'. Link: '+window.location.href;
  var wa=document.createElement('a'); wa.className='gehna-wa-btn';
  wa.href='https://wa.me/918500531018?text='+encodeURIComponent(msg);
  wa.target='_blank'; wa.rel='noopener';
  wa.innerHTML='<svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg> Ask on WhatsApp';
  /* Append after delivery bar if present */
  var db = document.querySelector('.gehna-delivery-bar');
  var insertAfter2 = db || document.querySelector('.gehna-social-badges') || document.querySelector('.gehna-trust-badges') || anchor;
  insertAfter2.insertAdjacentElement('afterend', wa);
}

function renderShippingBar(total){
  var bar=document.querySelector('.gehna-shipping-bar'); if(!bar) return;
  var rem=FREE_SHIP_THRESHOLD-total, pct=Math.min(100,Math.round((total/FREE_SHIP_THRESHOLD)*100));
  bar.innerHTML=rem>0
    ?'<div class="gehna-shipping-bar__text">Add <strong>&#8377;'+Math.ceil(rem/100)+' more</strong> to get <strong>FREE delivery</strong></div><div class="gehna-shipping-bar__track"><div class="gehna-shipping-bar__fill" style="width:'+pct+'%"></div></div>'
    :'<div class="gehna-shipping-bar__text">You have unlocked <strong>FREE delivery!</strong></div><div class="gehna-shipping-bar__track"><div class="gehna-shipping-bar__fill" style="width:100%"></div></div>';
}
function fetchCart(cb){fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(cb).catch(function(){});}
function injectShippingBar(){
  if(document.querySelector('.gehna-shipping-bar')) return;
  var priceEl=document.querySelector('[id^="price-"]'); if(!priceEl) return;
  var bar=document.createElement('div'); bar.className='gehna-shipping-bar';
  bar.innerHTML='<div class="gehna-shipping-bar__text">Checking...</div><div class="gehna-shipping-bar__track"><div class="gehna-shipping-bar__fill" style="width:0%"></div></div>';
  priceEl.insertAdjacentElement('afterend',bar);
  var refresh=function(){fetchCart(function(c){renderShippingBar(c.total_price);});};
  refresh();
  document.addEventListener('cart:refresh',refresh);
  document.addEventListener('cart:updated',refresh);
  /* Refresh the moment the shopper adds to cart (the only cart change on a PDP),
     with two short retries to let Shopify process the add. Replaces the old
     3-second forever-poll, so nothing runs on an idle product page. */
  document.addEventListener('click',function(e){
    if(e.target.closest && e.target.closest('.product-form__submit, .gehna-sticky-atc__btn')){
      setTimeout(refresh,500);
      setTimeout(refresh,1500);
    }
  });
}

function injectUrgency(){
  if(document.querySelector('.ub-wrap')) return;
  var wrap=document.createElement('div'); wrap.className='ub-wrap';
  var inv=null, invEl=document.querySelector('[id^="Inventory-"]');
  if(invEl){var m=(invEl.textContent||'').match(/(\d+)/);if(m)inv=parseInt(m[1],10);}
  if(inv!==null&&inv>0&&inv<=10){
    var isCrit=inv<=5, bEl=document.createElement('div');
    bEl.className='ub-badge '+(isCrit?'ub-critical':'ub-low');
    var bTxt=isCrit?(inv===1?'Only <strong>1 item</strong> left &mdash; order now!':'Only <strong>'+inv+' left</strong> in stock!'):'Low stock &mdash; only <strong>'+inv+' remaining</strong>';
    bEl.innerHTML='<span style="font-size:16px;flex-shrink:0">'+(isCrit?'&#128293;':'&#9889;')+'</span><span>'+bTxt+'</span>'+(isCrit?'<span class="ub-pulse"></span>':'');
    wrap.appendChild(bEl);
  }
  var vBase=8+Math.floor(Math.random()*16), vEl=document.createElement('div'); vEl.className='ub-viewers';
  vEl.innerHTML='<span class="ub-dot"></span><span id="ub-vc">'+vBase+'</span> people viewing this right now';
  wrap.appendChild(vEl);
  setInterval(function(){vBase=Math.max(5,Math.min(32,vBase+(Math.random()<.5?-1:1)));var e=document.getElementById('ub-vc');if(e)e.textContent=vBase;},4500);
  var tEl=document.createElement('div'); tEl.className='ub-timer';
  tEl.innerHTML='&#128336; Order within <strong id="ub-cd">--:--:--</strong> for same-day dispatch';
  wrap.appendChild(tEl);
  var pf=document.querySelector('product-form')||document.querySelector('form[action*="/cart/add"]');
  if(pf){pf.insertAdjacentElement('beforebegin',wrap);}else{var sb=document.querySelector('.product-form__submit');if(sb&&sb.parentNode)sb.parentNode.insertAdjacentElement('beforebegin',wrap);}
}

function injectWishlistHearts(){
  document.querySelectorAll('.card-wrapper').forEach(function(card){
    if(card.querySelector('.gehna-wish')) return;
    var btn=document.createElement('button'); btn.className='gehna-wish'; btn.setAttribute('aria-label','Save to wishlist');
    btn.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
    btn.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();var s=btn.dataset.saved==='1';btn.dataset.saved=s?'0':'1';btn.querySelector('svg').style.fill=s?'none':'#e53e3e';btn.querySelector('svg').style.stroke=s?'currentColor':'#e53e3e';});
    card.style.position='relative'; card.appendChild(btn);
  });
}

function ensureLazyLoad(){document.querySelectorAll('img:not([loading])').forEach(function(img){img.setAttribute('loading','lazy');});}
function headerScrollShadow(){var hw=document.querySelector('.header-wrapper');if(!hw)return;var t=false;window.addEventListener('scroll',function(){if(t)return;t=true;requestAnimationFrame(function(){hw.style.boxShadow=window.scrollY>60?'0 2px 20px rgba(0,0,0,.08)':'';t=false;});},{passive:true});}

function init(){
  injectWAFab(); injectBTT(); ensureLazyLoad(); injectWishlistHearts(); headerScrollShadow();
  if(document.querySelector('.product-form__submit')){
    injectStickyATC(); injectShippingBar(); injectUrgency();
    /* Trust badges, social proof, delivery bar and WA button all
       insert after the buy-buttons wrapper — so they appear below ATC. */
    injectTrustBadges(); injectDeliveryBar(); injectWAProductBtn();
  }
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
document.addEventListener('shopify:section:load',function(){injectWishlistHearts();});
/* Re-add hearts after Dawn's facet filtering AJAX-swaps the collection grid
   (which does not fire shopify:section:load). Debounced; injectWishlistHearts
   is idempotent, so it only decorates cards that don't have a heart yet. */
(function(){
  var grid=document.getElementById('ProductGridContainer');
  if(grid && 'MutationObserver' in window){
    var wt;
    new MutationObserver(function(){clearTimeout(wt);wt=setTimeout(injectWishlistHearts,150);}).observe(grid,{childList:true,subtree:true});
  }
})();

/* Safety net: remove any social-proof ribbon left in the DOM from a cached script. */
(function(){var el=document.querySelector('.gehna-social-proof'); if(el) el.remove();})();

})();
